import React from 'react';
import {
  faChevronRight,
  faClock,
  faReply,
  faTrashAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Reply from './Reply';
import { useDashboardContext } from '../../context';
import {
  useMessageDetailsMutation,
  useMessageViewStatusMutation
} from '../../../../features/authentication/messageApiSlice';
import PropTypes from 'prop-types';
import UiVirtualScroll from '../../../../components/VirtualScroll';
import { useGetAllAlertsMutation } from '../../../../features/authentication/authApiSlice';

import html2pdf from 'html2pdf.js';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import deleteMenu from '../../../../assets/images/deleteMenu.png';
import ProgressButton from '../../../../components/ProgressButton';
import { useGlobalContext } from '../../../../globalContext';

const Inbox = (props) => {
  const [replyCondition, setReplyCondition] = React.useState(false);
  const [messageDetail] = useMessageDetailsMutation();
  const [messageViewStatus] = useMessageViewStatusMutation();
  const [getAllAlerts] = useGetAllAlertsMutation();
  const [expand, setExpand] = React.useState(false);
  const [singlemessageDetails, setSinglemessageDetails] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedMessageId, setSelectedMessageId] = React.useState([]);
  const [activeIndex, setActiveIndex] = React.useState({
    index: 1,
    id: 0
  });
  const messageDetails = useDashboardContext();
  const context = useGlobalContext();
  const [showDeleteConfirmationNotification, setShowDeleteConfirmationNotification] = React.useState(false);
  const [singleDeleteId, setSingleDeleteId] = React.useState(false);
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);

  // the number of items that we want to keep in memory - 300
  const buffer = messageDetails.limit * 3;

  const cache = buffer - messageDetails.limit;

  React.useEffect(() => {
    messageDetails.setAllMessage([]);
    loadInitialData();
  }, [messageDetails.activeButton]);

  const loadMessageHandler = async (id) => {
    const allMessageGroupResponse = await messageDetail(id).unwrap();
    console.log(allMessageGroupResponse);
    setSinglemessageDetails(() => allMessageGroupResponse);
  };

  const expandhandler = async (index, id, viewed) => {
    setSinglemessageDetails();
    setReplyCondition(false);
    if (index !== activeIndex.index || !expand) {
      if (viewed == 0) {
        messageDetails.setAllMessage((prev) => {
          return prev.map((item) => {
            if (item.alertID === id) {
              return { ...item, viewed: 1 };
            }
            return item;
          });
        });
        await messageViewStatus(id).unwrap();
        const messageCountResponse = await context.getMessageCountAsync();
        props.setMessageCount(messageCountResponse);
      }
      setSelectedMessageId(id);
      loadMessageHandler(id);
    } else {
      setSelectedMessageId();
    }
    setActiveIndex({ index: index == activeIndex.index ? -1 : index, id: id });
    setExpand(index !== activeIndex.index || !expand);
  };

  async function getAllAlertsAsync(skip, take, type) {
    try {
      const allAlertsResponse = await getAllAlerts({
        skip: skip,
        take: take,
        viewType: type,
        orderBy: messageDetails.activeButton
      }).unwrap();
      console.log(allAlertsResponse);
      return allAlertsResponse;
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  const loadInitialData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(0, buffer, 1);
    messageDetails.setAllMessage(data);
    messageDetails.setNoOFInboxMessage(total);
    setIsLoading(false);
  };

  const prevCallback = async (newOffset) => {
    messageDetails.setSkip(newOffset);
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(newOffset, messageDetails.limit, 1);
    const newItems = [...data, ...messageDetails.allMessage.slice(0, cache)];
    messageDetails.setAllMessage(newItems);
    messageDetails.setNoOFInboxMessage(total);
    setIsLoading(false);
  };

  const nextCallback = async (newOffset) => {
    messageDetails.setSkip(newOffset);
    setIsLoading(true);
    const { total, data } = await getAllAlertsAsync(
      newOffset, // Skip the initial cache
      messageDetails.limit,
      1
    );

    const newItems = [...messageDetails.allMessage.slice(-cache), ...data];
    messageDetails.setAllMessage(newItems);
    messageDetails.setNoOFInboxMessage(total);
    setIsLoading(false);
  };

  const selectHandler = (value) => {
    if (messageDetails.messageDetail.selectedMessages.includes(value.alertID)) {
      // If the checkbox is already selected, remove it from the array
      const updatedSelectedMessages = messageDetails.messageDetail.selectedMessages.filter(
        (id) => id !== value.alertID
      );
      messageDetails.setMessageDetail(() => ({
        ...messageDetails.messageDetail,
        selectedMessages: updatedSelectedMessages,
        allInboxChecked: false
      }));
    } else {
      // If the checkbox is not selected, add it to the array
      messageDetails.setMessageDetail(() => ({
        ...messageDetails.messageDetail,
        selectedMessages: [...messageDetails.messageDetail.selectedMessages, value.alertID],
        allInboxChecked: false
      }));
    }
  };

  const deleteHandler = async (id) => {
    setSingleDeleteId(id);
    setShowDeleteConfirmationNotification(true);
  };

  const deleteSingleMessage = async (status) => {
    setShowDeleteConfirmationNotification(false);
    if (status) {
      try {
        await messageDetails.deleteHandler(singleDeleteId);
        await context.getAllAlertsAsync(1);
        setActiveIndex(-1);
      } catch (error) {
        console.log(error);
      }
    } else {
      setSingleDeleteId(null);
    }
  };

  const handlePrint = async (index) => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const options = {
      margin: 60,
      filename: 'InboxMessage.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
    };

    const contentWrapper = document.getElementById('index-' + index);
    const contentClone = contentWrapper.cloneNode(true);
    const buttonElements = contentClone.querySelectorAll('button');
    buttonElements.forEach((buttonElement) => {
      buttonElement.classList.add('d-none');
    });

    const subjectTag = contentClone.getElementsByClassName('subjectH6Tag')[0];
    if (subjectTag) {
      subjectTag.style.whiteSpace = 'initial';
      subjectTag.classList.add('mb-3');
      var parentDiv = subjectTag.parentNode;
      if (parentDiv) {
        parentDiv.classList.remove('d-flex');
      }
    }

    const inputElements = contentClone.querySelectorAll('input');
    inputElements.forEach((inputElement) => {
      inputElement.classList.add('d-none');
    });

    await html2pdf().set(options).from(contentClone).save('InboxMessage.pdf');
    setIsPdfGenerating(false);
  };

  const replayOnClick = async (fName, lName, studentId) => {
    if (messageDetails.isReplayMessage == false) {
      setReplyCondition(true);
      messageDetails.setIsReplayMessage(true);
    } else {
      setReplyCondition(!replyCondition);
      messageDetails.setIsReplayMessage(!replyCondition);
    }

    const newObject = {
      fName: fName,
      lName: lName,
      login: '',
      studentId: studentId
    };
    messageDetails.setSlectedStudents([newObject]);
  };

  return (
    <UiVirtualScroll
      buffer={buffer}
      rowHeight={95}
      height="400px"
      total={messageDetails.noOFInboxMessage}
      limit={messageDetails.limit}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      onPrevCallback={prevCallback}
      onNextCallback={nextCallback}>
      {messageDetails.allMessage?.map((value, index) => (
        <>
          <div
            key={index}
            className={`message-box ${
              value.viewed == 0 && 'unread_messages'
            } overflow-auto position-relative mb-3`}
            id={`index-${index}`}>
            <div className="message-header  d-flex flex-column flex-md-row align-items-md-center">
              <div className="form-check flex-shrink-0 me-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={value.alertID}
                  id={`checkbox-${index}`}
                  onChange={() => selectHandler(value)}
                  checked={messageDetails.messageDetail.selectedMessages.includes(value.alertID)}
                />
              </div>
              <div className="message-content d-flex  flex-column flex-sm-row  align-items-sm-center w-100 mt-3 mt-md-0">
                <div className="message-user rounded-circle flex-shrink-0 me-3 mb-3 mb-sm-0">
                  {`${value?.fName?.slice(0, 1).toUpperCase()}${value?.lName
                    ?.slice(0, 1)
                    .toUpperCase()}`}
                </div>
                <div className="message-content-in w-100">
                  <div className="d-flex flex-column flex-md-row">
                    <h6 className="subjectH6Tag mb-0 text-truncate order-2 order-md-1">
                      {value.subject}
                    </h6>

                    <div className="message-date d-flex flex-wrap gap-2 order-1 order-md-2 flex-shrink-0 mb-2 mb-md-0 ms-md-auto">
                      <span style={{ marginRight: '5px' }}>
                        <FontAwesomeIcon className="me-2" icon={faUser} />
                        {value.lName + ' ' + value.fName}
                      </span>
                      <span>
                        <FontAwesomeIcon className="me-2" icon={faClock} />
                        {new Date(value.tStamp)
                          .toLocaleString('default', {
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: true
                          })
                          .replace(/\//g, '-')}
                      </span>
                    </div>
                  </div>
                  {value.alertID !== selectedMessageId && (
                    <p className="mt-2 mb-0 text-truncate"> {value.message}</p>
                  )}
                </div>
              </div>
              <button
                onClick={() => expandhandler(index, value.alertID, value.viewed)}
                className="message-icon rounded-circle">
                <FontAwesomeIcon
                  style={{
                    transform: `${
                      activeIndex.index == index && expand ? 'rotate(90deg)' : 'rotate(0deg)'
                    }`
                  }}
                  icon={faChevronRight}
                />
              </button>
            </div>

            {activeIndex.index == index && expand && (
              <div className="message-details pt-3">
                {singlemessageDetails?.assignmentName && (
                  <p>
                    Assignment Name: <strong>{singlemessageDetails.assignmentName}</strong>
                  </p>
                )}
                {singlemessageDetails?.course && (
                  <p>
                    Course: <strong>{singlemessageDetails.course}</strong>
                  </p>
                )}
                {singlemessageDetails?.activity && (
                  <p>
                    Activity: <strong>{singlemessageDetails.activity}</strong>
                  </p>
                )}
                {singlemessageDetails?.message && (
                  <p className="mt-3">{singlemessageDetails.message}</p>
                )}
                <div className="mt-4 d-flex gap-3">
                  <button
                    onClick={() => deleteHandler(value.alertID)}
                    className="btn btn-castleWhite btn-width">
                    <FontAwesomeIcon className="me-2" icon={faTrashAlt} /> Delete
                  </button>
                  <button
                    onClick={() => replayOnClick(value.fName, value.lName, value.fromUserID)}
                    className="btn btn-castleRed btn-width">
                    <FontAwesomeIcon className="me-2" icon={faReply} /> Reply
                  </button>
                  <ProgressButton
                    isLoading={isPdfGenerating}
                    onClick={() => handlePrint(index)}
                    loadingLabel="Generating PDF"
                    label="Print to PDF"
                    className="btn btn-castleRed"
                    expectedDuration={1500}
                  />
                </div>
              </div>
            )}
          </div>
          {replyCondition && messageDetails.isReplayMessage && activeIndex.index == index && (
            <Reply
              close={setReplyCondition}
              fromUser={`${value.fName} ${value.lName}`}
              fromUserId={value.fromUserID}
              subject={value.subject}
            />
          )}
        </>
      ))}
      <ConfirmationModal
        isOpen={showDeleteConfirmationNotification}
        onClose={() => deleteSingleMessage(false)}
        onSave={() => deleteSingleMessage(true)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'Are you sure that you want to delete the message? The operation cannot be UNDONE!'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
        showIcon={true}
        icon={deleteMenu}
      />
      {/* <LoadMore /> */}
    </UiVirtualScroll>
  );
};

Inbox.propTypes = {
  messageDetails: PropTypes.object,
  singlemessageDetails: PropTypes.object,
  loadMessageHandler: PropTypes.func,
  setMessageCount: PropTypes.func
};

export default Inbox;
